export const getEventInfo = (type, needJSON = false) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const pagetitle = page?.category?.pageType

  const eventInfo = {
    eventAction: `${pagetitle}:select a product required for installation:${type}`,
    eventName: `${pagetitle}:select a product required for installation:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "items required for install",
    internalLinkType: `${pagetitle}:select a product required for installation:${type}`,
    internalLinkZoneName: `${pagetitle}:select a product required for installation`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const pushAnalyticsData = (title, productInfoObj) => {
  const eventInfo = getEventInfo(title, true)
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const productInfo = productInfoObj
    ? JSON.parse(productInfoObj)?.productInfo
    : null
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    productInfo,
  })
}
